const SocialMediaManage = () => import('@/views/social-media/social-media-index-view.vue');
const SocialMediaInbox = () => import('@/views/social-media/social-media-inbox-view.vue');
const SocialMediaPosts = () => import('@/views/social-media/social-media-posts.vue');
const SocialMediaPostsSingleView = () => import('@/views/social-media/social-media-post-single-view.vue');
const SocialMediaPostsPreview = () => import('@/views/social-media/social-media-post-preview.vue');
const SocialMediaPostsSingleEdit = () => import('@/views/social-media/social-media-post-single-edit.vue');
const SocialMediaPostTemplates = () => import('@/views/social-media/templates/social-media-post-templates-index.vue');
const SocialMediaAnalytics = () => import('@/views/social-media/social-media-analytics-index-view');

export default [
    {
        path: '/SocialMedias',
        name: 'SocialMedias',
        component: SocialMediaManage,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-media-page',
            pageTitle: 'Social Media'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias',
        name: 'ClientsSocialMedias',
        component: SocialMediaManage,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-media-page',
            pageTitle: 'Social Media'
        }
    },
    {
        path: '/SocialMediaAnalytics',
        name: 'SocialMediaAnalyticsIndex',
        component: SocialMediaAnalytics,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-media-page',
            pageTitle: 'Social Media Analytics',
        },
    },
    {
        path: '/Clients/:clientId/SocialMediaAnalytics',
        name: 'ClientsSocialMediaAnalyticsIndex',
        component: SocialMediaAnalytics,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-media-page',
            pageTitle: 'Social Media Analytics',
        },
    },
    {
        path: '/SocialMedias/SocialPosts',
        name: 'SocialPosts',
        component: SocialMediaPosts,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/SocialPosts',
        name: 'ClientsSocialPosts',
        component: SocialMediaPosts,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/SocialMedias/SocialPosts/Post/:id',
        name: 'SinglePostView',
        component: SocialMediaPostsSingleView,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/SocialPosts/Post/:id',
        name: 'ClientsSinglePostView',
        component: SocialMediaPostsSingleView,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/SocialMedias/SocialPosts/Post/Preview/:id',
        name: 'SinglePostPreview',
        component: SocialMediaPostsPreview,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: false,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/SocialPosts/Post/Preview/:id',
        name: 'ClientsSinglePostPreview',
        component: SocialMediaPostsPreview,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: false,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/SocialMedias/SocialPosts/Post/:id/Edit',
        name: 'SinglePostEditById',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/SocialPosts/Post/:id/Edit',
        name: 'ClientsSinglePostEditById',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/SocialMedias/SocialPosts/Create',
        name: 'SinglePostEdit',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        },
    },
    {
        path: '/Clients/:clientId/SocialMedias/SocialPosts/Create',
        name: 'ClientsSinglePostEdit',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        },
    },
    {
        path: '/SocialMedias/PostTemplates',
        name: 'SocialPostTemplates',
        component: SocialMediaPostTemplates,
        meta: {
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Post Templates'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/PostTemplates',
        name: 'ClientsPostTemplates',
        component: SocialMediaPostTemplates,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Post Templates'
        }
    },
    {
        path: '/Agencies/:agencyId/SocialMedias/PostTemplates',
        name: 'AgencyPostTemplates',
        component: SocialMediaPostTemplates,
        meta: {
            type: 'agency',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Post Templates'
        }
    },
    {
        path: '/SocialMedias/PostTemplates/Create',
        name: 'SinglePostTemplateEdit',
        component: SocialMediaPostsSingleEdit,
        meta: {
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Post Templates'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/PostTemplates/Create',
        name: 'ClientsSinglePostTemplateEdit',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Post Templates'
        }
    },
    {
        path: '/Agencies/:agencyId/SocialMedias/PostTemplates/Create',
        name: 'AgencySinglePostTemplateEdit',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'agency',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Post Templates'
        }
    },
    {
        path: '/SocialMedias/PostTemplates/Template/:id/Edit',
        name: 'SinglePostTemplateEditById',
        component: SocialMediaPostsSingleEdit,
        meta: {
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/PostTemplates/Template/:id/Edit',
        name: 'ClientsSinglePostTemplateEditById',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Agencies/:agencyId/SocialMedias/PostTemplates/Template/:id/Edit',
        name: 'AgencySinglePostTemplateEditById',
        component: SocialMediaPostsSingleEdit,
        meta: {
            type: 'agency',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/SocialMedias/PostTemplates/Template/Preview/:postTemplateId',
        name: 'SinglePostTemplatePreview',
        component: SocialMediaPostsPreview,
        meta: {
            subtype: 'social',
            isUiShown: false,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Clients/:clientId/SocialMedias/PostTemplates/Template/Preview/:postTemplateId',
        name: 'ClientsSinglePostTemplatePreview',
        component: SocialMediaPostsPreview,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: false,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/Agencies/:agencyId/SocialMedias/PostTemplates/Template/Preview/:postTemplateId',
        name: 'AgencySinglePostTemplatePreview',
        component: SocialMediaPostsPreview,
        meta: {
            type: 'agency',
            subtype: 'social',
            isUiShown: false,
            pageClass: 'social-posts-page',
            pageTitle: 'Social Posts'
        }
    },
    {
        path: '/SocialMediaInbox',
        name: 'SocialMediaInbox',
        component: SocialMediaInbox,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-media-page',
            pageTitle: 'Social Media Inbox',
        },
    },
    {
        path: '/Clients/:clientId/SocialMediaInbox',
        name: 'ClientsSocialMediaInbox',
        component: SocialMediaInbox,
        meta: {
            type: 'client',
            subtype: 'social',
            isUiShown: true,
            pageClass: 'social-media-page',
            pageTitle: 'Social Media Inbox',
        },
    },
];
